import { useState, useEffect } from 'react';
import './pendingVerification.css';
import { useSelector } from 'react-redux';
import { toCamelCase, setActivity, getdata, useProfile, useLoanByOpportunityId } from '../../Global/Index';
import ClipLoader from 'react-spinners/ClipLoader';
import { ToastContainer, toast } from 'react-toastify';
import { useTheme } from "@mui/material";

const override = {
  display: "block",
  margin: "10% auto",
  marginLeft: '50%'
};


const handleApiStatusErrors = (apiStatusDashboard, apiStatusProfile, loanData) => {
  if (!apiStatusDashboard || !apiStatusProfile) return;

  if (apiStatusDashboard == "500" || apiStatusProfile == '500') {
    toast.error('something went wrong. Please try again later!')
  } else if (apiStatusDashboard == '503' || apiStatusProfile == '503') {
    toast.warn(loanData.response.message);
  } else if (apiStatusDashboard == '419' || apiStatusProfile == '419') {
    window.location.href = "/Session-Expired"
  } else if (apiStatusDashboard == '401' || apiStatusProfile == '401') {
    window.location.href = '/'
  }
};


const handleInitialDataFetch = async (setOppertunityId, setActivity) => {
  const data = await getdata();
  if (data.response.status == '200') {
    setOppertunityId(data.response.data.OpportunityId);
  } else if (data.response.status === "503") {
    toast.warn(data.response.message);
  } else if (data.response.status === "419") {
    window.location.href = '/Session-Expired';
  }
  setActivity('Pending Verification Page');
};


const renderVerificationButton = (isVerified) => {
  return isVerified ? (
    <button id="button">Verified</button>
  ) : (
    <button id="nbutton">Not Verified</button>
  );
};


const isFieldVerified = (field) => {
  return field && field.toString().trim() !== "";
};

// Helper function to render contact details
const renderContactDetails = (profiledata) => {
  if (!profiledata) return null;

  return (
    <div className="status">
      {renderVerificationButton(isFieldVerified(profiledata.mobile))}
      {renderVerificationButton(isFieldVerified(profiledata.email))}
    </div>
  );
};

const PendingVerification = () => {
  const themename = useSelector((state) => state.theme);
  const [oppertunityId, setOppertunityId] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    const getdatafunction = async () => {
      await handleInitialDataFetch(setOppertunityId, setActivity);
    }
    getdatafunction();
  }, []);

  const { data: loanData, loan, isLoading: isLoadingLoan, error: loanError } = useLoanByOpportunityId(oppertunityId);
  const { data: profileData, isLoading: isLoadingProfile, error: profileError } = useProfile();

  const isLoading = isLoadingLoan || isLoadingProfile || loanError || profileError;

  let apiStatusDashboard = null;
  let apiStatusProfile = null;

  if (loanData) {
    apiStatusDashboard = loanData.response.status;
  }


  if (profileData) {
    apiStatusProfile = profileData.response.status;
  }

  // Handling API status errors
  handleApiStatusErrors(apiStatusDashboard, apiStatusProfile, loanData);

  // Safely extracting profiledata if exists
  let profiledata = profileData?.response?.data ?? null;

  return (
    <>
      <ToastContainer />

      <div className="maincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
        <h2>Pending Verification of Contact Details</h2>

        {isLoading ? (
          <div className="loading-container" style={{ textAlign: 'center' }}>
            <ClipLoader
              color={theme.palette.maincolor.light}
              loading={true}
              cssOverride={override}
              size={30}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <div className={`mainsubcontainer ${themename === "dark" ? "dark" : "light"}`}>
            <div className='pendingVerification_container'>
              <div className="pendingVerification_main">
                {loan && <h3>{toCamelCase(loan.LoanAccountName)}</h3>}
                <div className="detail_main">
                  <div className="details">
                    <div className="mobile">
                      <h4>MOBILE NO.</h4>
                      <h4>EMAIL ID</h4>
                    </div>
                    {renderContactDetails(profiledata)}
                    <div className="contact">
                      <h4>{profiledata?.mobile?.toString().trim() || "NA"}</h4>
                      <h4>{profiledata?.email?.toString().trim() || "NA"}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PendingVerification;

